import React from 'react';
import styles from './ContactPage.module.css';

const ContactPage = () => {
  return (
    <div className={styles.page}>
      {/* Hero Section */}
      <header className={styles.hero}>
        <div className={styles.container}>
          <h1>Get in touch.</h1>
          <p className={styles.subtitle}>
            Whether you have a question about your AI weekly plan, need technical support, 
            or want to explore a partnership, we’re here to help you build your best week.
          </p>
        </div>
      </header>

      {/* Contact Grid Section */}
      <section className={styles.contactSection}>
        <div className={styles.container}>
          <div className={styles.grid}>
            
            {/* General & Technical Support */}
            <div className={styles.card}>
              <div className={styles.icon}>👋</div>
              <h2>App Support & Feedback</h2>
              <p>
                Having trouble generating a plan? Found a bug? Or just have a feature request 
                for a future update? Reach out to our core support team.
              </p>
              <a href="mailto:support@leanweekai.com" className={styles.contactLink}>
                support@leanweekai.com
              </a>
            </div>

            {/* Privacy & Data */}
            <div className={styles.card}>
              <div className={styles.icon}>🔒</div>
              <h2>Privacy & Data Inquiries</h2>
              <p>
                LeanWeek-AI is local-first, meaning your data lives on your device. You can delete 
                everything directly in the app settings. For broader privacy questions or specific 
                GDPR/CCPA inquiries, contact our privacy officer.
              </p>
              <a href="mailto:privacy@leanweekai.com" className={styles.contactLink}>
                privacy@leanweekai.com
              </a>
            </div>

            {/* Partnerships & Media */}
            <div className={styles.card}>
              <div className={styles.icon}>🤝</div>
              <h2>Partnerships & Press</h2>
              <p>
                Are you a fitness professional, creator, or journalist looking to review 
                LeanWeek-AI? We’d love to collaborate and share our mission of private, 
                sustainable fat-loss support.
              </p>
              <a href="mailto:press@leanweekai.com" className={styles.contactLink}>
                press@leanweekai.com
              </a>
            </div>

          </div>
        </div>
      </section>

      {/* Mailing Address Section */}
      <section className={styles.addressSection}>
        <div className={styles.container}>
          <div className={styles.addressBox}>
            <h3>Company Information</h3>
            <p>LeanWeek-AI</p>
            <p>[Your Company / Legal Entity Name]</p>
            <p>[Your Street Address or PO Box]</p>
            <p>[City, Country, Postal Code]</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;